// src/components/ResponsiveOrderContainer.jsx
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import DesktopSideDrawer from "./DesktopSideDrawer";
import MobileBottomSheet from "./MobileBottomSheet";

export default function ResponsiveOrderContainer() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  return isMobile ? <MobileBottomSheet /> : <DesktopSideDrawer />;
}
